import Dictionary from "utils/classes/dictionary";

export default class EnumClass{
  static _getNameProperty(name:string):string{
    return name;
  }

  static getDictionary <T = any>(): Dictionary<string,T>{
    let d = new Dictionary<string,T>();
    let keys = Object.keys(this);
    let values = Object.values(this);
    for (let i = 0; i < keys.length; i++) {
      d.append(this._getNameProperty(keys[i]),values[i]);
    }
    return d;
  }
}